import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/homepage.styles'
import Navbar from '../Navbar'
import Menu from '../Menu'
import VisibilitySensor from '../VisibilitySensor'
import Sidebar from '../Sidebar/Sidebar'
import { HomePageConfig } from '../configuration'
import { useMediaQuery } from '@material-ui/core'
import useElementVisible from '../app/hooks/useElementVisible'
import OnViewPortObserver from '../OnViewPortObserver'
import { CharacterReveal } from 'react-text-reveal'
import 'ken-burns-carousel';


const useStyles = makeStyles(styles)

export default function Homepage() {
    const isMobile = useMediaQuery('(max-width: 760px)')
    const classes = useStyles()
    const [elementsVisible, setElementsVisible] = useElementVisible({
        title: false,
        subTitle: false
    })
    return (
        <div id={HomePageConfig.id} className={classes.root} >
            <video className={classes.video} autoPlay loop playsInline muted >
                {isMobile ? <source src={HomePageConfig.videoUrlMobile}/> : <source src={HomePageConfig.videoUrl} /> }
            </video>
            <VisibilitySensor index={0} />
            <OnViewPortObserver
                onEnterViewPort={() => setElementsVisible('title')}
            />
            <OnViewPortObserver
                onEnterViewPort={() => setElementsVisible('subTitle')}
            />
            <Menu list={HomePageConfig.MenuSideBarElements} />
            <Navbar btnColor={HomePageConfig.navbar.btnColor} btnBackground={HomePageConfig.navbar.btnBackground} />
            <Sidebar elements={HomePageConfig.MenuSideBarElements} />
            <CharacterReveal
                animateOpacity={false}
                canPlay={elementsVisible.title}
                className={classes.h1}
                characterOffsetDelay={0}
                copy={[HomePageConfig.title]}
                direction={"bottom"}
                duration={800}
                ease={"cubic-bezier(0,0.4,0.4,1)"}
                offset={"100px"}
                multilineMasking={true}
                multilineOffsetDelay={0}
            />
            <CharacterReveal
                animateOpacity={false}
                canPlay={elementsVisible.subTitle}
                className={classes.h3}
                characterOffsetDelay={20}
                copy={[HomePageConfig.secondary]}
                direction={"bottom"}
                duration={1000}
                ease={"cubic-bezier(0,0.4,0.4,1)"}
                offset={"100px"}
                multilineMasking={true}
                multilineOffsetDelay={0}
            />
        </div>
    )
}